/* carry-fixes.js — correctifs post-publication (CDN de carry-antler.js fige) */

/* carrousel des cartes produit : les fleches .havinbag-card-arrow n'avaient
   aucun handler ; delegation en phase capture, bloque le lien etire. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.havinbag-card-arrow');
  if (!btn) return;
  if (e.__carryNavDone) return;
  e.__carryNavDone = true;
  e.preventDefault();
  e.stopPropagation();
  var nav = btn.closest('.havinbag-card-nav');
  var media = btn.closest('.media');
  if (!nav || !media) return;
  var urls = (nav.getAttribute('data-images') || '').split('|').filter(Boolean);
  if (urls.length < 2) return;
  var idx = parseInt(nav.getAttribute('data-idx') || '0', 10) || 0;
  var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
  idx = (idx + dir + urls.length) % urls.length;
  nav.setAttribute('data-idx', String(idx));
  media.querySelectorAll('img').forEach(function (img) {
    img.removeAttribute('srcset');
    img.src = urls[idx];
  });
}, true);

/* modal Sizes v2 : chaque carte affiche l'image de SA variante
   (couleur selectionnee + taille de la carte, via /products/<handle>.js).
   Fallback : image de la couleur active du carrousel. */
(function () {
  if (window.__carrySizesV2) return;
  window.__carrySizesV2 = true;
  var produit = null, charge = false;
  function chargerProduit(cb) {
    if (charge) { cb(produit); return; }
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) {
      var can = document.querySelector('link[rel="canonical"]');
      if (can) { m = (can.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/); }
    }
    if (!m) { charge = true; cb(null); return; }
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { charge = true; produit = p; cb(p); })
      .catch(function () { charge = true; cb(null); });
  }
  function imageCourante() {
    var act = document.querySelector('.product__media-list .is-active img')
      || document.querySelector('.product__media-list li img');
    return act ? (act.currentSrc || act.src) : '';
  }
  function selectionCourante() {
    var vals = [];
    document.querySelectorAll('.product-form__input').forEach(function (fs) {
      var sel = fs.querySelector('select');
      if (sel) { vals.push(sel.value); return; }
      var rad = fs.querySelector('input[type="radio"]:checked');
      if (rad) vals.push(rad.value);
    });
    return vals;
  }
  function maj() {
    var cartes = document.querySelectorAll('.carry-sizes-modal__card');
    if (!cartes.length) return;
    var fallback = imageCourante();
    chargerProduit(function (p) {
      var vals = selectionCourante();
      var idxT = -1;
      if (p && p.options) {
        for (var i = 0; i < p.options.length; i++) {
          var nom = typeof p.options[i] === 'string' ? p.options[i] : p.options[i].name;
          if (/size|taille/i.test(nom)) { idxT = i; }
        }
      }
      cartes.forEach(function (c) {
        var im = c.querySelector('img');
        if (!im) return;
        var src = '';
        if (p && idxT > -1 && vals.length === p.options.length) {
          var cible = vals.slice();
          cible[idxT] = c.getAttribute('data-value');
          for (var j = 0; j < p.variants.length; j++) {
            var v = p.variants[j];
            var opts = [v.option1, v.option2, v.option3];
            var ok = true;
            for (var k = 0; k < cible.length; k++) {
              if (opts[k] !== cible[k]) { ok = false; break; }
            }
            if (ok) { src = (v.featured_image && v.featured_image.src) || ''; break; }
          }
        }
        if (!src) { src = fallback; }
        if (!src) return;
        im.removeAttribute('srcset');
        im.src = src;
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.carry-sizes-row')) maj();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) {
      setTimeout(maj, 450);
    }
  }, true);
})();

/* sticky Add to bag mobile : apparait quand le bouton principal sort de l'ecran,
   delegue le clic au vrai bouton (flux Dawn + drawer panier conserves). */
(function () {
  function vraiBouton() { return document.querySelector('.product-form__submit'); }
  if (!vraiBouton()) return;
  if (document.querySelector('.carry-sticky-atc')) return;

  var bar = document.createElement('div');
  bar.className = 'carry-sticky-atc';
  bar.innerHTML = '<div class="carry-sticky-atc__info">'
    + '<div class="carry-sticky-atc__name"></div>'
    + '<div class="carry-sticky-atc__price"></div></div>'
    + '<button type="button" class="carry-sticky-atc__btn">Add to bag</button>';
  document.body.appendChild(bar);

  function maj() {
    var h = document.querySelector('.product__title h1');
    var nom = '';
    if (h) {
      var s = h.querySelector('span');
      nom = (s ? s.textContent : h.textContent).trim();
    }
    bar.querySelector('.carry-sticky-atc__name').textContent = nom;
    var p = document.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular, .product__info-container .price-item');
    bar.querySelector('.carry-sticky-atc__price').textContent = p ? p.textContent.trim().split('\n')[0] : '';
    var vb = vraiBouton();
    var b = bar.querySelector('.carry-sticky-atc__btn');
    if (vb) {
      b.disabled = vb.disabled;
      if (vb.disabled) { b.textContent = 'Sold out'; }
      else { b.textContent = 'Add to bag'; }
    }
  }

  bar.querySelector('.carry-sticky-atc__btn').addEventListener('click', function () {
    var vb = vraiBouton();
    if (vb && !vb.disabled) vb.click();
  });

  function horsVue() {
    var vb = vraiBouton();
    if (!vb) return false;
    var r = vb.getBoundingClientRect();
    return r.bottom < 0 || r.top > window.innerHeight;
  }
  function rafraichir() {
    bar.classList.toggle('is-visible', horsVue() && window.innerWidth < 750);
  }
  var io = new IntersectionObserver(function () { rafraichir(); });
  var attente = false;
  window.addEventListener('scroll', function () {
    if (attente) return;
    attente = true;
    requestAnimationFrame(function () { rafraichir(); attente = false; });
  }, { passive: true });
  var observe = null;
  function observer() {
    var vb = vraiBouton();
    if (!vb || vb === observe) return;
    if (observe) io.unobserve(observe);
    io.observe(vb);
    observe = vb;
  }
  observer();
  maj();
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.product-form__input, variant-selects, variant-radios')) {
      setTimeout(function () { maj(); observer(); }, 450);
    }
  }, true);
})();
